import firebase from 'firebase/app'
import 'firebase/firestore'
import '@firebase/auth';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCr-6R6wV1CiS7JGcg14qiMZgfBoUvUljQ",
    authDomain: "ssucollab.firebaseapp.com",
    projectId: "ssucollab",
    storageBucket: "ssucollab.appspot.com",
    messagingSenderId: "591489201988",
    appId: "1:591489201988:web:f10b734dc31496d97ac911",
    measurementId: "G-XK2421Q34B"
  };


  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider()

export { auth, provider}
export default db;


